(function(){
  if (window.__dbQbZoomInit) return;
  window.__dbQbZoomInit = true;
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-qb-zoom-btn]');
    if(!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('aria-controls');
    if(!id) return;
    var pswp = document.getElementById(id);
    if(!pswp) return;
    var isDefined = (window.customElements && customElements.get('product-image-zoom'));
    if(isDefined){
      if(typeof pswp.showModal === 'function'){ pswp.showModal(); return; }
      try{ pswp.open = true; return; }catch(_){}
    }
    pswp.setAttribute('open','');
    pswp.classList.add('pswp--open');
  }, true);
})();